type FormatCurrencyOptions = {
  decimals?: number
  currencyFormat?: string
  locale?: string
}

export const formatCurrencyLocale = (value: string, options: FormatCurrencyOptions = {}): string => {
  if (!value) return ""

  const { decimals = 2, currencyFormat = "{amount}", locale = navigator.language } = options

  // Allow the user to type in decimal places (e.g., "44.0")
  if ((decimals > 0 && value.endsWith(".")) || value.endsWith(".0")) {
    return value
  }

  // Remove only commas for numeric parsing, retain period for decimals
  const numericValue = parseFloat(value.replace(/,/g, ""))

  // Return the original value if NaN (e.g., when user types ".")
  if (isNaN(numericValue)) {
    return value
  }

  // Format the numeric value using Intl.NumberFormat
  const formattedValue = new Intl.NumberFormat(locale, {
    maximumFractionDigits: decimals,
  }).format(numericValue)

  // Use the provided currency format to replace "{amount}"
  const formatted = currencyFormat.replace("{amount}", formattedValue)
  return formatted
}
